import { createPlugin, createApiFactory, configApiRef, createComponentExtension } from '@backstage/core-plugin-api';
import { createCardExtension } from '@backstage/plugin-home-react';
import { s as stackOverflowApiRef, S as StackOverflowClient } from './esm/StackOverflowClient-bbc10006.esm.js';
export { s as stackOverflowApiRef } from './esm/StackOverflowClient-bbc10006.esm.js';
import React from 'react';
import 'cross-fetch';
import 'qs';

const stackOverflowPlugin = createPlugin({
  id: "stack-overflow",
  apis: [
    createApiFactory({
      api: stackOverflowApiRef,
      deps: { configApi: configApiRef },
      factory: ({ configApi }) => StackOverflowClient.fromConfig(configApi)
    })
  ]
});
const StackOverflowSearchResultListItem = stackOverflowPlugin.provide(
  createComponentExtension({
    name: "StackOverflowResultListItem",
    component: {
      lazy: () => import('./esm/index-8936f2dc.esm.js').then(
        (m) => m.StackOverflowSearchResultListItem
      )
    }
  })
);
const HomePageStackOverflowQuestions = stackOverflowPlugin.provide(
  createCardExtension({
    name: "HomePageStackOverflowQuestions",
    title: "Stack Overflow Questions",
    components: () => import('./esm/index-770372c8.esm.js')
  })
);

const StackOverflowIcon = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox: "0 0 125 125",
      width: "25",
      height: "25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("path", { d: "M84.021 75.825v31H11v-31H0v42h95v-42H84.021z", fill: "#BCBBBB" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M21.057 96.825H74v-10H21.057v10zm1.058-23.915l51.428 10.794 2.117-10.265L24.23 62.645 22.115 72.91zm6.773-24.656l47.618 22.222 4.445-9.524L33.33 38.73l-4.444 9.524zm13.227-23.386l40.423 33.65 6.773-8.042-40.53-33.65-6.666 8.042zM68.147 0L59.68 6.243l31.323 42.222 8.465-6.243L68.147 0z",
        fill: "#F48024"
      }
    )
  );
};

export { HomePageStackOverflowQuestions, StackOverflowIcon, StackOverflowSearchResultListItem, stackOverflowPlugin };
//# sourceMappingURL=index.esm.js.map
